const reduxConfig = {
  appName: '@@k',
};

export default reduxConfig;
